import CategoryList from "../Shop/CategoryList";
import styles from "./CategoryMenu.module.scss";

interface CategoryMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

const CategoryMenu: React.FC<CategoryMenuProps> = ({ isOpen, onClose }) => {
  return (
    <div>
      {isOpen && (
        <div className={styles.menuCategoryOverlay} onClick={onClose}>
          <div
            className={styles.menuCategotyContent}
            onClick={(e) => e.stopPropagation()}
          >
            <CategoryList isMenu={true} onClose={onClose} />
          </div>
        </div>
      )}
    </div>
  );
};

export default CategoryMenu;
